import * as React from 'react';
import classNames from 'classnames';
const TransBtn = ({ className, customizeIcon, customizeIconProps, disabled, onMouseDown, onClick, children }) => {
    let icon;
    if (typeof customizeIcon === 'function') {
        icon = customizeIcon(customizeIconProps);
    }
    else {
        icon = customizeIcon;
    }
    return (<span className={className} onMouseDown={event => {
            event.preventDefault();
            if (onMouseDown) {
                onMouseDown(event);
            }
        }} style={{
            userSelect: 'none',
            WebkitUserSelect: 'none'
        }} unselectable="on" onClick={onClick} aria-disabled={disabled} aria-hidden>
            {icon !== undefined ? (icon) : (<span className={classNames(className.split(/\s+/).map(cls => `${cls}-icon`))}>
                    {children}
                </span>)}
        </span>);
};
export default TransBtn;
